export const mockData = {
  whatsappLink: 'https://wa.me/6281326713216?text=Halo,%20saya%20tertarik%20dengan%20layanan%20hosting%20RDM',
  
  stats: [
    { value: '99.9%', label: 'Uptime Server' },
    { value: '24/7', label: 'Support Aktif' },
    { value: '100+', label: 'Madrasah Terlayani' }
  ],
  
  features: [
    {
      icon: 'Server',
      title: 'Server 24/7',
      description: 'Server hosting yang aktif 24 jam non-stop dengan infrastruktur enterprise untuk menjamin ketersediaan sistem RDM Anda.',
      benefits: [
        'Uptime 99.9% dengan monitoring real-time',
        'Server berlokasi di Indonesia untuk akses cepat',
        'Backup otomatis setiap hari',
        'Perlindungan DDoS dan keamanan berlapis'
      ]
    },
    {
      icon: 'HeadphonesIcon',
      title: 'Support Teknis',
      description: 'Tim support profesional yang siap membantu Anda melalui berbagai channel komunikasi kapan pun dibutuhkan.',
      benefits: [
        'Respon cepat melalui WhatsApp dan email',
        'Tim ahli berpengalaman dalam sistem RDM',
        'Panduan lengkap dan dokumentasi',
        'Remote assistance untuk troubleshooting'
      ]
    },
    {
      icon: 'Download',
      title: 'Instalasi Gratis',
      description: 'Kami tangani seluruh proses instalasi dan konfigurasi sistem RDM hingga siap digunakan oleh madrasah Anda.',
      benefits: [
        'Setup awal tanpa biaya tambahan',
        'Konfigurasi database dan sistem',
        'Import data siswa dan guru',
        'Training penggunaan untuk operator'
      ]
    }
  ],
  
  whyChooseUs: [
    {
      icon: 'Shield',
      title: 'Keamanan Terjamin',
      description: 'Data madrasah Anda dilindungi dengan enkripsi SSL dan backup otomatis harian ke multiple server.'
    },
    {
      icon: 'Clock',
      title: 'Performa Optimal',
      description: 'Server dengan spesifikasi tinggi dan optimasi khusus untuk aplikasi RDM memastikan akses cepat dan lancar.'
    },
    {
      icon: 'Check',
      title: 'Harga Kompetitif',
      description: 'Dapatkan layanan hosting berkualitas enterprise dengan harga yang terjangkau untuk madrasah.'
    }
  ],
  
  testimonials: [
    {
      name: 'Ahmad Fauzi, S.Pd.I',
      position: 'Kepala Madrasah',
      school: 'MTs Negeri 1 Jakarta',
      feedback: 'Sejak menggunakan layanan hosting dari nja, proses penilaian rapor digital di madrasah kami menjadi jauh lebih lancar. Support timnya sangat responsif dan membantu.'
    },
    {
      name: 'Siti Aminah, M.Pd',
      position: 'Operator RDM',
      school: 'MA Muhammadiyah Surabaya',
      feedback: 'Instalasi yang cepat dan mudah, server stabil tanpa downtime. Tim support sangat membantu ketika kami mengalami kendala. Sangat direkomendasikan!'
    },
    {
      name: 'Muhammad Ridwan',
      position: 'Wakil Kepala Madrasah',
      school: 'MTs Al-Ikhlas Bandung',
      feedback: 'Pelayanan profesional dengan harga yang kompetitif. Server cepat dan support 24/7 yang benar-benar aktif. Terima kasih nja!'
    }
  ],
  
  faqs: [
    {
      question: 'Apa itu RDM dan mengapa madrasah membutuhkan hosting?',
      answer: 'RDM (Rapor Digital Madrasah) adalah sistem penilaian rapor digital yang dikembangkan Kemenag RI. Madrasah membutuhkan hosting untuk memastikan sistem RDM dapat diakses 24/7 dengan performa optimal, keamanan data terjamin, dan dukungan teknis yang memadai.'
    },
    {
      question: 'Berapa lama proses instalasi RDM di hosting?',
      answer: 'Proses instalasi biasanya memakan waktu 1-2 hari kerja setelah pembayaran dikonfirmasi. Kami akan menangani semua aspek teknis termasuk setup database, konfigurasi sistem, dan testing hingga RDM siap digunakan oleh madrasah Anda.'
    },
    {
      question: 'Apakah data madrasah kami aman?',
      answer: 'Sangat aman. Kami menggunakan enkripsi SSL untuk semua koneksi, melakukan backup otomatis harian, dan menyimpan data di data center tier-3 di Indonesia dengan sistem keamanan berlapis. Data Anda juga terlindungi dari serangan DDoS dan malware.'
    },
    {
      question: 'Bagaimana jika terjadi masalah teknis?',
      answer: 'Tim support kami siap membantu 24/7 melalui WhatsApp, email, dan remote assistance. Kami berkomitmen untuk merespon dalam waktu maksimal 2 jam untuk masalah kritis dan menyediakan solusi secepat mungkin.'
    },
    {
      question: 'Apakah bisa migrasi dari hosting lain?',
      answer: 'Tentu saja bisa. Tim kami akan membantu proses migrasi data dari hosting lama ke server kami tanpa biaya tambahan. Kami akan memastikan tidak ada data yang hilang dan sistem berjalan dengan lancar setelah migrasi.'
    },
    {
      question: 'Berapa kapasitas yang disediakan untuk hosting RDM?',
      answer: 'Kapasitas hosting disesuaikan dengan jumlah siswa di madrasah Anda. Kami menyediakan storage yang cukup untuk data siswa, guru, nilai, dan file-file penting lainnya dengan opsi upgrade jika diperlukan di masa mendatang.'
    }
  ]
};